import {Controller} from "stimulus"

let draggable
let ghostElement

export default class extends Controller {

    connect() {
        console.log("hello from inspectionPlanner");
    }

    updateReport(e) {
        console.log("report changed");
        const reportDate = document.getElementById("for_date")
        window.location.href = '?for_date=' + reportDate.value;
    }

    dragInspection(e) {
        console.log("dragging inspection");
        e.target.classList.add("opacity-30")
        draggable = e.target
        console.info(draggable);
    }

    touchInspection(e) {
        console.log("touching inspection");
        e.preventDefault();
        draggable = e.target.closest(".inspection-visit")
        // Create ghost element
        ghostElement = draggable.cloneNode(true);
        ghostElement.classList.add("opacity-50", "fixed", "pointer-events-none", "z-50");
        document.body.appendChild(ghostElement);

        // Position ghost element at touch position
        const touch = e.touches[0];
        ghostElement.style.left = (touch.clientX - 5) + 'px';
        ghostElement.style.top = (touch.clientY - ghostElement.offsetHeight / 2) + 'px';

        document.addEventListener('touchmove', handleTouchMove);
    }

    dragStopInspection(e) {
        console.log("done dragging inspection");
        e.target.classList.remove("opacity-30")
        document.removeEventListener('touchmove', handleTouchMove);

        // Remove ghost element
        if (ghostElement) {
            ghostElement.remove();
            ghostElement = null;
        }
    }

    onAssignable(e) {
        e.preventDefault();
        console.log('over an assignable inspector');
        return true;
    }

    visitAssignable(e) {
        console.log("can assign to inspector")
        e.target.classList.add("animate-pulse")
        setTimeout(function () {
            e.target.classList.remove("animate-pulse");
        }, 3000);
        return true;
    }

    leaveAssignable(e) {
        console.log("left assignable inspector")
        e.target.classList.remove("animate-pulse")

    }


    assignTouchedInspection(e) {
        e.preventDefault();
        console.log("assigning to inspector")
        const touch = e.changedTouches[0];
        const lastTouchedElement = document.elementFromPoint(touch.clientX, touch.clientY);
        document.removeEventListener('touchmove', handleTouchMove);

        // Remove ghost element
        if (ghostElement) {
            ghostElement.remove();
            ghostElement = null;
        }

        if (lastTouchedElement.closest(".inspector-column")) {
            lastTouchedElement.closest(".inspector-column").querySelector(".inspector-schedule").prepend(draggable);
            const inspectorid = lastTouchedElement.closest(".inspector-column").dataset.inspectorId;
            const inspectionId = draggable.dataset.inspectionId;
            const inspectionVisitId = draggable.dataset.inspectionVisitId;
            updateInspectionVisit(inspectorid, inspectionId, inspectionVisitId, draggable);
            draggable.classList.remove("opacity-30");
            draggable.classList.add("animate-pulse");
            setTimeout(function () {
                draggable.classList.remove("animate-pulse");
            }, 1000);
        }
    }

    assignInspection(e) {
        e.preventDefault();
        console.log("assigning to inspector")
        const inspectorid = e.target.closest(".inspector-column").dataset.inspectorId;
        const inspectionId = draggable.dataset.inspectionId;
        const inspectionVisitId = draggable.dataset.inspectionVisitId;
        updateInspectionVisit(inspectorid, inspectionId, inspectionVisitId, draggable);
        e.target.closest(".inspector-column").querySelector(".inspector-schedule").prepend(draggable);
        draggable.classList.remove("opacity-30");
        draggable.classList.add("animate-pulse");
        setTimeout(function () {
            draggable.classList.remove("animate-pulse");
        }, 1000);
    }
}

function updateInspectionVisit(inspectorid, inspectionId, inspectionVisitId, inspectionElement) {
    // Use inspectionElement instead of DOM query
    let relatedVisitIds = [];
    if (inspectionElement && inspectionElement.dataset.relatedVisitIds) {
        try {
            relatedVisitIds = JSON.parse(inspectionElement.dataset.relatedVisitIds);
        } catch (e) {
            relatedVisitIds = inspectionElement.dataset.relatedVisitIds.split(',').map(id => id.trim()).filter(Boolean);
        }
    }

    let assignRelated = false;
    if (relatedVisitIds.length > 0) {
        assignRelated = window.confirm(
            `This visit is related to ${relatedVisitIds.length} others.\nAssign all to this inspector as well?`
        );
    }

    fetch(`/inspections/${inspectionId}/inspection_visits/${inspectionVisitId}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
            inspection_visit: {
                performed_by_id: inspectorid
            },
            related_visit_ids: assignRelated ? relatedVisitIds : []
        })
    })
        .then(response => response.json())
        .then(data => {
            console.log(data);

            // Visually move related visits if assigned
            if (assignRelated && relatedVisitIds.length > 0) {
                relatedVisitIds.forEach(id => {
                    const relatedEl = document.querySelector(`.inspection-visit[data-inspection-visit-id='${id}']`);
                    if (relatedEl) {
                        const targetColumn = document.querySelector(`.inspector-column[data-inspector-id="${inspectorid}"] .inspector-schedule`);
                        if (targetColumn) {
                            targetColumn.prepend(relatedEl);
                            relatedEl.classList.add("animate-pulse");
                            setTimeout(() => {
                                relatedEl.classList.remove("animate-pulse");
                            }, 1000);
                        }
                    }
                });
            }

            document.querySelectorAll(".inspector-column").forEach((inspector) => {
                if (inspector.querySelector(".inspector-count") != null) {
                    inspector.querySelector(".inspector-count").innerHTML =
                        inspector.querySelectorAll(".inspection-visit").length || '0';
                }
            });
        });
}

function handleTouchMove(e) {
    const touch = e.touches[0];

    // Update ghost element position
    if (ghostElement) {
        ghostElement.style.left = (touch.clientX - 5) + 'px';
        ghostElement.style.top = (touch.clientY - ghostElement.offsetHeight / 2) + 'px';
    }

    // Get the height of the viewport and content
    const viewportHeight = window.innerHeight;
    const scrollTriggerDistance = 100;

    // Scroll down when near bottom
    if (touch.clientY > viewportHeight - scrollTriggerDistance) {
        window.scrollBy(0, 10);
    }

    // Scroll up when near top
    if (touch.clientY < scrollTriggerDistance) {
        window.scrollBy(0, -10);
    }

    e.preventDefault();
}